import config from "../config/application";
import { postBodyService, getService} from "./base.service";

const urlFindCEntitiesByCountry = 'conciliation/find_centities/';
const urlConciliationDaily = 'conciliation/daily/total';
const urlConciliationList = 'conciliation/find_list';
const urlConciliationListBank = 'conciliation/daily/find_list_bank';
const urlConciliationListIncome = 'conciliation/daily/find_list_income';

class ConciliationMonitorService {
    getBankingList(country) {
        const url = `${config.data.income.conciliationMonitor.url}${urlFindCEntitiesByCountry}${country}`;
        return getService(url);
    }

    getConciliationDaily(json) {
        const url = `${config.data.income.conciliationMonitor.url}${urlConciliationDaily}`;
        return postBodyService(url, json);
    }

    getConciliationList(json) {
        const url = `${config.data.income.conciliationMonitor.url}${urlConciliationList}`;
        return postBodyService(url, json);
    }

    getConciliationListBank(json) {
        const url = `${config.data.income.conciliationMonitor.url}${urlConciliationListBank}`;
        return postBodyService(url, json);
    }

    getConciliationListIncome(json) {
        const url = `${config.data.income.conciliationMonitor.url}${urlConciliationListIncome}`;
        return postBodyService(url, json);
    }
}
export default new ConciliationMonitorService(); 